module.exports = __webpack_public_path__ + "static/img/per_apply_bg.5564884.png";


//////////////////
// WEBPACK FOOTER
// ./src/fe/mo/gameResult/imgs/per_apply_bg.png
// module id = YskK
// module chunks = 1